var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never", "body-style": { padding: 0 } } },
        [
          _c("order-table", {
            attrs: { params: _vm.queryParams, list: _vm.list },
          }),
          _c("pagination", {
            attrs: {
              total: _vm.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }